const tryParseJSONObject = str => {
    const failedToParseErr = 'Failed to parse cloud response';
    try {
        var o = JSON.parse(str);
        if (o && typeof o === 'object') {
            return o;
        }
    }
    catch (e) {
        return {error: failedToParseErr};
    }
    return {error: failedToParseErr};
};

const alertInterval = 120; // show alert max once per 2 min.
const timeLimit = 43200; // 12 hours
const showWarningsAfter = 40000; // start warnings after 40000 seconds
const getNow = () => Math.floor(new Date().valueOf() / 1000);
const TokenHasExpired = delta => delta > timeLimit; 
const TokenWillExpireSoon = delta => delta > showWarningsAfter; 
const GetMinsRemaining = delta => Math.floor((timeLimit - delta) / 60);
const GetWarningMsg = delta => {
    if (TokenHasExpired(delta)) return '⚠ Your session has expired.';
    if (TokenWillExpireSoon(delta)) return `⚠ Your session will expire in ${GetMinsRemaining(delta)} minutes. Please save your work, then refresh the page.`;
};
const RecentlyShowedWarning = now => {
    if (!b3.lastMessageShownTime) return;
    return(now - b3.lastMessageShownTime < alertInterval);
};
const HandleTokenExpiryWarning = (now, delta) => {
    const msg = GetWarningMsg(delta);
    if (!msg) return;
    if (RecentlyShowedWarning(now)) return;
    alert(msg);
    b3.lastMessageShownTime = now;
};

// How long ago was the token issued in seconds
const GetTokenDelta = now => {
    const timestamp = Number(token.authMessage.split(',')[1]);
    if (timestamp === NaN) return 0;
    return(now - timestamp);
};

export const beadCloud = async config => {
    if (!loggedIn) return;
    if (!token) return;
    config.token = token;

    const now = getNow();
    const delta = GetTokenDelta(now);
    HandleTokenExpiryWarning(now, delta);
    if (TokenHasExpired(delta)) return {error: 'Failed to fetch from cloud'};

    const body = JSON.stringify(config);
    const method = 'POST';
    const endpoint = 'https://beadfunc.azurewebsites.net/api/MyFirstHttpTriggerFunc?';
    let response;
    try {
        const thing = await fetch(endpoint, {method, body});
        const text = await thing.text();
        response = tryParseJSONObject(text);
    } catch {
        response = {error: 'Failed to fetch from cloud'};
    }
    if (response.error) {
        console.error(response.error);
    }
    return response;
};

export const browserFields = [
    'title', 'id', 'thumbnail', 'beadCount', 'settings', 'description', 'tags', 'dateCreated', 'dateModified', 'credits'
];
